<script>
import WorkflowForm from './WorkflowForm'


export default {
  components: {
    WorkflowForm
  },

  props: {
    active: {
      type: Boolean,
      default: false
    },
    workflow: {
      type: Object
    }
  },

  data() {
    return {
      internalActive: this.active
    }
  },

  watch: {
    active() {
      this.internalActive = this.active
    },

    internalActive() {
      this.$emit('update:active', this.internalActive)
    }
  }
}
</script>

<template>
  <b-modal :active.sync="internalActive" scroll="keep" class="big-modal" width="900">

    <workflow-form :workflow="workflow" @save="$emit('reload')" @cancel="internalActive = false"></workflow-form>

  </b-modal>
</template>

<style lang="scss">
.big-modal .modal-content {
  max-width: 90% !important;
}
</style>
